import React from 'react';

interface LetterProps {
  ch: string;
  size?: number;
  hero?: boolean;
  spinning?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Letter card hero. Container is a squircle with paper-grain background;
 * the glyph itself is `letter-glyph` so we can blur during spin.
 */
export function Letter({ ch, size = 96, hero, spinning, className = '', style }: LetterProps) {
  const dim = size * 1.3;
  return (
    <div
      className={`letter-card ${hero ? 'hero' : ''} ${spinning ? 'spinning' : ''} ${className}`}
      style={{
        width: dim,
        height: dim,
        fontSize: size,
        ...style,
      }}
      aria-label={`Letter ${ch}`}
    >
      <span className="letter-glyph">{ch}</span>
    </div>
  );
}
